import { Box, Button, MenuItem, Select, TextField, Typography } from '@material-ui/core';
import React, { ChangeEvent, FC, useState } from 'react';
import { useDataProvider, useNotify, useRefresh } from 'react-admin';
import { countries } from '../../helpers/country';


interface Props {
    closeModal: () => void;
    openAdd: (add: boolean, create: boolean) => void;
    id: string
}

interface SelectCountries {
    id: string;
    name: string
}

const CreateReferral: FC<Props> = ({ closeModal, openAdd, id }) => {
    const dataProvider = useDataProvider()
    const notify = useNotify()
    const refresh = useRefresh()
    countries.sort()
    const countryObject = (countries: Array<string>) => {
        let result = countries.reduce((agg,item,i) => {
            agg.push({id: item, name: item})
            return agg
        },Array<SelectCountries>())
        return result
    }
    const [state, setState] = useState({
        name: '',
        surname: '',
        email: '',
        phone: '',
        country: "UK",
        isBlocked: false,
        referredBy: id,
        isNewReferral: true
    })

    const [errors, setErrors] = useState({
        name: false,
        surname: false,
        email: false,
        phone: false,
    })
    const saveReferral = async () => {
        const requiredErrors = {
            name: state.name.length === 0 ? true : false,
            surname: state.surname.length === 0 ? true : false,
            email: state.email.length === 0 ? true : false,
            phone: state.phone.length === 0 ? true : false,
        }
        if (requiredErrors.name || requiredErrors.surname || requiredErrors.email || requiredErrors.phone) {
            setErrors(requiredErrors)
            return
        }

        if (!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(state.email)) {
            setErrors({ ...errors, email: true })
            return
        }
        if (!/^[^!@#$^%&*()"':;<>?/,|0-9]*$/.test(state.name)) {
            setErrors({ ...errors, name: true })
            return
        }
        if (!/^[^!@#$^%&*()"':;<>?/,|0-9]*$/.test(state.surname)) {
            setErrors({ ...errors, surname: true })
            return
        }
        if (!/^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i.test(state.phone)) {
            setErrors({ ...errors, phone: true })
            return
        }
        let data = state
        data.referredBy = id
        data.isNewReferral = true
        try {
            const result = await dataProvider.create('users/cms', { data: data })
            if (result.data) {
                notify("User created", "info")
                refresh()
            }
        } catch (error) {
            notify(error, "error")
        }

    }

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.currentTarget.name === "phone") {
            const onlyNumbers = /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i
            if (!onlyNumbers.test(event.currentTarget.value) && event.currentTarget.value.length > 0) {
                return
            }
        }
        
        setState({ ...state, [event.currentTarget.name]: event.currentTarget.value })
    }

    const changeStatus = (event: React.ChangeEvent<HTMLInputElement>) => {
        setState({ ...state, isBlocked: !state.isBlocked })
    }

    const handleSelect = (event): void => {
        const selectedCountry = event.target.value
        setState({ ...state, country: selectedCountry })
    }

    const toSearch = () => {
        openAdd(true, false)
    }
    return (
        <>
            <Box display="flex" justifyContent="center">
                <Typography className="base-color" variant="h6">
                    Add new Referral
        </Typography>
            </Box>
            <Box padding="4em">
                <Box display="flex" justifyContent="flex-start" alignItems="baseline" width="50%">
                    <Typography gutterBottom className="base-color">
                        First Name
                </Typography>
                    <TextField
                        onChange={handleChange}
                        name='name'
                        value={state.name}
                        className="referral-fields"
                        label=""
                    />
                </Box>
                <Box display="flex" justifyContent="center">
                    {state.name.length === 0 && errors.name && <div className="validate-address-error">Required</div>}
                    {state.name.length > 0 && errors.name && <div className="validate-address-error">Invalid characters</div>}
                </Box>
                <Box display="flex" justifyContent="flex-start" alignItems="baseline" width="50%">
                    <Typography gutterBottom className="base-color">
                        Last Name
                </Typography>
                    <TextField
                        onChange={handleChange}
                        name='surname'
                        value={state.surname}
                        className="referral-fields"
                        label=""
                    />
                </Box>
                <Box display="flex" justifyContent="center">
                    {state.surname.length === 0 && errors.surname && <div className="validate-address-error">Required</div>}
                    {state.surname.length > 0 && errors.surname && <div className="validate-address-error">Invalid characters</div>}
                </Box>
                <Box display="flex" justifyContent="flex-start" alignItems="baseline" width="50%">
                    <Typography gutterBottom className="base-color">
                        Email address
                </Typography>
                    <TextField
                        onChange={handleChange}
                        name='email'
                        value={state.email}
                        className="referral-fields"
                        label=""
                    />
                </Box>
                <Box display="flex" justifyContent="center">
                    {state.email.length === 0 && errors.email && <div className="validate-address-error">Required</div>}
                    {state.email.length > 0 && errors.email && <div className="validate-email-error">Must be a valid email</div>}
                </Box>
                <Box display="flex" justifyContent="flex-start" alignItems="baseline" width="50%">
                    <Typography gutterBottom className="base-color">
                        Phone
                </Typography>
                    <TextField
                        name='phone'
                        value={state.phone}
                        className="referral-fields"
                        onChange={handleChange}
                        label=""
                    />
                </Box>
                <Box display="flex" justifyContent="center">
                    {state.phone.length === 0 && errors.phone && <div className="validate-address-error">Required</div>}
                    {state.phone.length > 0 && errors.phone && <div className="validate-address-error">must be only the numbers</div>}
                </Box>
                <Box display="flex" justifyContent="flex-start" alignItems="baseline" width="50%">
                    <Typography className="base-color">
                        Competition
                    </Typography>
                    <Select
                        id="select-input"
                        value={state.country}
                        onChange={handleSelect}
                        name="competition"
                        className="referral-fields"
                    >
                        {countryObject(countries).map((name) => (
                            <MenuItem key={name.name} value={name.name} >
                                {name.name}
                            </MenuItem>
                        ))}
                    </Select>
                </Box>
                <Box display="flex" justifyContent="flex-start" alignItems="center" width="50%" marginTop="8px">
                    <Typography className="base-color">
                        Status
                </Typography>
                    <label className="switch ">
                        <input type="checkbox" checked={!state.isBlocked} onChange={changeStatus} />
                        <span className="slider round"></span>
                    </label>
                </Box>
            </Box>
            <Box display="flex" justifyContent="space-evenly" alignItems="center" paddingTop="1em" >
                <div className="move-search-user" onClick={toSearch}> Move to search user</div>
                <Button className="user-cancel-button user-modal-buttons" /*disabled={!state.selectedUser}*/ onClick={saveReferral}>Save</Button>
                <Button className="user-cancel-button user-modal-buttons" onClick={closeModal}>Cancel</Button>
            </Box>
        </>
    )
}

export default CreateReferral